<template>
    <div class="stock_in_Detail">
        
        <el-form  ref="addForm" :rules="rules" :model="addForm" style="width:100%;" class="add_form">
            <el-card class="table_searchbar">
                <el-row >
                    <el-col :span='7'>
                        <div class="">
                            <span class="title">出库类型：</span>
                            <el-form-item  style="display:inline-block">
                                <el-select size="small" style="max-width:180px;" @change="typeSelect" v-model="addForm.stockOutType" placeholder="出库类型" filterable >
                                    <el-option v-for="item in stockOutTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>    
                            </el-form-item>                 
                        </div>
                    </el-col>
                    <el-col :span='7'>
                        <div class="">
                            <span class="title">出库时间：</span>
                            <el-form-item prop="stockOutTime"  :rules="rules.stockOutTime" style="display:inline-block">
                                <el-date-picker style="width:186px;" v-model="addForm.stockOutTime" type="datetime"  value-format='yyyy-MM-dd HH:mm:ss' placeholder="选择日期时间"></el-date-picker>             
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span='7'>
                        <div class="">
                            <span class="title">申请人：</span>
                            <el-form-item prop="applicantId" :rules="rules.applicantId" style="display:inline-block">
                                <el-select  size="small" style="max-width:180px;" v-model="addForm.applicantId" placeholder="申请人" filterable>
                                    <el-option v-for="item in applicantList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                                        
                        </div>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="table-card" style="height: 720px">
                <el-row style="margin-bottom:20px">
                    <el-button type="primary" icon="el-icon-plus" size="small" @click="addMaterial">新增物料</el-button>
                </el-row>
            
                <el-table v-if="addForm.stockOutType"  :data='addForm.stockList' border :span-method="arraySpanMethod" :style="W?{maxHeight:'570px',height:'auto',overflowY: 'scroll'}:{maxHeight:'523px',height:'auto',overflowY: 'scroll'}">
                    <el-table-column   label="物料编码" min-width="140">
                        <template slot-scope="scope">
                            <el-form-item  :rules="rules.outCount" style="display:inline-block">
                                <el-select  @visible-change='selectFinish($event,scope.$index)'  @change="materialSelect($event,scope.$index)"
                                    filterable  remote :remote-method="query=>{remoteMethod(query,'','',scope.$index)}" :loading="loading" size="small" popper-class='select_width'  v-model="scope.row.materialId" placeholder="物料编码"  style="display:block">
                                    <el-option v-for="item in scope.row.materialList" :key="item.id"   :label="item.materialCode" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column   label="物料名称" min-width="140">
                        <template slot-scope="scope">
                            <el-form-item  :rules="rules.outCount" style="display:inline-block">
                                <el-select  @visible-change='selectFinish($event,scope.$index)'  @change="materialSelect($event,scope.$index)"
                                    filterable  remote :remote-method="query=>{remoteMethod('',query,'',scope.$index)}" :loading="loading" size="small" popper-class='select_width'  v-model="scope.row.materialId" placeholder="物料编码"  style="display:block">
                                    <el-option v-for="item in scope.row.materialList" :key="item.id"   :label="item.materialName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column   label="规格" min-width="140">
                        <template slot-scope="scope">
                            <el-form-item  :rules="rules.outCount" style="display:inline-block">
                                <el-select  @visible-change='selectFinish($event,scope.$index)'  @change="materialSelect($event,scope.$index)"
                                    filterable  remote :remote-method="query=>{remoteMethod('','',query,scope.$index)}" :loading="loading" size="small" popper-class='select_width'  v-model="scope.row.materialId" placeholder="物料编码"  style="display:block">
                                    <el-option v-for="item in scope.row.materialList" :key="item.id"   :label="item.specification" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column  label="总出库量"  min-width="60">
                        <template slot-scope="scope">
                            <el-form-item  :rules="rules.outCount" style="display:inline-block">
                                {{scope.row.allCount}}
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column  label="单位"  min-width="60">
                        <template slot-scope="scope">
                            <el-form-item  style="display:inline-block">
                                {{scope.row.unitOfQuantity}}
                            </el-form-item>
                        </template> 
                    </el-table-column> 
                    
                    
                    <el-table-column prop="productionBatch" label="批次" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item  style="display:inline-block">
                                {{scope.row.productionBatchCode}} 
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column  label="仓库"  min-width="90">
                        <template slot-scope="scope">
                            <el-form-item  style="display:inline-block">
                                {{scope.row.warehouseName}}
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column  label="仓位"  min-width="90">
                        <template slot-scope="scope">
                            <el-form-item  style="display:inline-block">
                                {{scope.row.factoryName}}
                            </el-form-item>
                        </template>
                    </el-table-column>
                    
                    <el-table-column  label="可用数量"  min-width="60">
                        <template slot-scope="scope">
                            <el-form-item  style="display:inline-block">
                                {{scope.row.availableAmount}}
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column  label="出库数量"  min-width="120">
                        <template slot-scope="scope">
                            <el-form-item :prop="`stockList[${scope.$index}]`" :rules="rules.outCount" style="display:inline-block">
                                <el-input :disabled="scope.row.disabled" style="display: inline-block; width: 66%;" @change="outCountChange($event,scope)" v-model="scope.row.amount" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column prop="unitTypeId" label="单位"  min-width="70">
                        <template slot-scope="scope">
                            <el-form-item  style="display:inline-block">
                                <el-select  @change="unitTypeChange($event,scope)" size="small" popper-class='select_width'  v-model="scope.row.unitTypeId" placeholder="单位"  style="display:block">
                                    <el-option v-for="item in scope.row.unitTypeList" :key="item.unitTypeId" :label="item.unitOfQuantity" :value="item.unitTypeId"></el-option>
                                </el-select>
                            </el-form-item>
                        </template> 
                    </el-table-column>

                    <el-table-column prop="materialName" label="操作"  width="60" >
                        <template slot-scope="scope">
                            <div class="delete"   type="primary"  @click="deleteMaterial(scope.$index,scope.row.index)"></div>
                        </template>
                    </el-table-column>
                </el-table>
                
                <el-row style="margin:20px 0 0px 0;text-align: center;">
                    <el-button type="primary"  size="small" @click="backToOrderView">返回</el-button>
                    <el-button type="primary"  size="small" @click="submit">提交</el-button>
                </el-row>
            </el-card>
        </el-form>
    </div>
</template>
<script>
import CommonUtils from '../../util/CommonUtils'

export default {
    name: 'StockOutEdit',
    props:{
        selectInfo:null
    },
    data(){
        return{
            W:false,
            stockOutTypeOption:[
                // {id: 1, label: '盘点出库', value: 1},
                {id: 2, label: '销售出库', value: 2},
                // {id: 3, label: '领料出库', value: 3},
                {id: 4, label: '直接出库', value: 4},
            ],
            materialBaseList:[],
            index:null,
            loading:false,
            materialList:[],
            addForm:{
                stockOutType:null,
                stockOutTime:null,
                applicantId:null,
                stockList:[{
                    num:1,
                    unitTypeList:[]
                }]
            },
            applicantList:[],  
            rules:{
                stockOutTime:[
                    { required: true, message: '请选择出库时间', trigger: 'blur' },
                ],
                applicantId:[
                    { required: true, message: '请选择申请人', trigger: 'blur' },
                ],
                outCount:[
                  
                    {validator(rule, value, callback) {
                            let amount = value.amount
                            
                            if ( amount == '' ||amount==0||amount==null||amount==undefined) {
                                callback()
                            } else {
                                amount = Number(amount)
                               
                                if(isNaN(amount)){
                                    callback(new Error('出库数量必须为数字'))
                                }else{
                                    if(amount<0){
                                        callback(new Error('出库数量不能小于零'))
                                    }else{
                                        let availableAmount = value.availableAmount
                                        if(amount>availableAmount){
                                            callback(new Error('出库数量不能大于可用数量'))
                                        }else{
                                            callback()
                                        }
                                    }
                                }
                                
                            }
                        },trigger: 'blur'}
                ],
            }
        }
    },
	mounted:async function(){
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        this.loadApplicantList()
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    deactivated:function(){
        console.log("deactivated");
    },
    methods:{
        loadApplicantList(){
            this.$RequestUtil.post({
                url: '/api/select/listWorker',
                params: {},
                type:'sync',
                success: (res) => {
                    if(res.code == 0){
                        this.applicantList = res.data;
                    }
                }
            });
        },

        unitTypeChange(ev,scope){
            let ratio = (scope.row.unitTypeList.find(item=>item.unitTypeId==ev)||{ratio:1}).ratio
            let availableAmount = this.keepTwoDecimal(scope.row.baseAvailableAmount/ratio)
            
            if(scope.row.amount){
                this.outCountChange(scope.row.amount,scope)
            }
            scope.row.ratio = ratio
            this.$set(scope.row,'availableAmount',availableAmount)

        },

        keepTwoDecimal(n) {
            n = Number(n)
            return Math.round(n * 100) / 100
        },

        async typeSelect(ev,index){
            this.materialBaseList = await this.loadMaterialList()
            this.$set(this.addForm.stockList[0],'materialList',CommonUtils.cloneObj(this.materialBaseList))
        },

        outCountChange(ev,scope){
            // if(!Number.isInteger(Number(ev)) || Number(ev)<=0){
            //     this.$message.warning('出库数量必须为正整数')
            //     this.$set(scope.row,'amount',null)
            //     return
            // } 
            //向上查找第一个num存在的row

            let ratio = (scope.row.unitTypeList.find(item=>item.unitTypeId==scope.row.unitTypeId)||{ratio:1}).ratio
            let index = -1
            for(let i=0;i<=scope.$index;i++){
                if(this.addForm.stockList[i].num){
                    index = i
                }
            }
            let allCount;
            if(scope.row.lastCount){
                allCount = Number(this.addForm.stockList[index].allCount)+ratio*Number(ev) - scope.row.lastCount
            }else{
                allCount = Number(this.addForm.stockList[index].allCount)+ratio*Number(ev)
            }
            scope.row.lastCount = ratio*Number(ev)
            this.$set(this.addForm.stockList[index],'allCount',allCount)
        },

        arraySpanMethod({ row, column, rowIndex, columnIndex }){
            if(columnIndex > 4&&columnIndex<11){
                return [1,1];
            }
            if(columnIndex <= 4||columnIndex == 11){
                if(row.num){
                    return [row.num,1];
                }else{
                    return [0,0]
                }
            }
        },

        

        submit(){
            this.$refs['addForm'].validate((valid) => {
                if(valid){
                    let materialVOS = []
                    let isPass = true
                    this.addForm.stockList.forEach(item=>{   
                        if(item.num){
                            materialVOS.push({
                                materialId:item.materialId,
                                unitTypeId:item.baseUnitTypeId,
                                stockOutDetailVOS:[
                                    {
                                        stockId:item.stockId,
                                        amount:item.amount||0,
                                        unitTypeId:item.unitTypeId
                                    }
                                ]
                            })
                            if(item.outCount==0){
                                isPass = false
                            }
                        }else{
                            let len = materialVOS.length - 1
                            log(len,materialVOS[len],888)
                            materialVOS[len].stockOutDetailVOS.push({
                                stockId:item.stockId,
                                amount:item.amount||0,
                                unitTypeId:item.unitTypeId
                            })
                        }
                    })
                    if(!isPass){
                        this.$message.error('总出库量必须大于零')
                        return 
                    }
                    let params = {
                        stockOutType:this.addForm.stockOutType,
                        stockOutTime:this.addForm.stockOutTime,
                        applicantId:this.addForm.applicantId,
                        materialVOS
                    }
                    this.$RequestUtil.post({
                        url: '/api/stock/application/stockOut',
                        type:'sync',
                        params,
                        success:res=>{
                            if(res.code==0){
                                this.$message.success('新增成功')
                                this.backToOrderView()
                                
                            }else{
                                this.$message.error(res.message||res.msg)
                            }
                        }
                    })
                }
            })
        },
        
        selectFinish(ev,index){
            if(!ev){
                this.remoteMethod('','','',index)
            }
        },

        async materialSelect(ev,index){
            let info = await this.loadStockListByMaterialId(ev)
            let selectMaterialInfo = this.addForm.stockList[index].materialList.find(item=>item.id==ev)||{}
            let num = info.length
            if(info.length==0){
                this.$message.error('当前选择物料暂无库存数据')
                num = 1
                return
            }
            info[0].materialList = CommonUtils.cloneObj(this.addForm.stockList[index].materialList)
            this.addForm.stockList.splice(index,this.addForm.stockList[index].num)
            
            info.forEach(item=>{
                item.unitTypeList = selectMaterialInfo.unitTypeList
                item.materialId = selectMaterialInfo.materialId
                item.unitOfQuantity = selectMaterialInfo.unitOfQuantity
                item.unitTypeId = selectMaterialInfo.unitTypeId
                item.baseUnitTypeId = selectMaterialInfo.unitTypeId
                item.baseAvailableAmount = item.availableAmount
                item.allCount = 0
            })
            
            this.addForm.stockList.splice(index,0,...info)
            this.addForm.stockList[index].num = num
        },

        //通过物料id查询物料所有仓库库存
        async loadStockListByMaterialId(materialId) { 
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/stock/listStockByMaterial',params: {materialId}})
            if(code==0){
                return data
            }else{
                this.$message.error(msg||message)
            }
        },

        async remoteMethod(materialCode,materialName,specification,index) {
            this.loading = true;
            let data = await this.loadMaterialList(materialCode,materialName,specification)
            this.loading = false
            this.addForm.stockList[index].materialList = data
            this.$set(this.addForm.stockList[index],'materialList',data)
        },

        async loadMaterialList(materialCode,materialName,specification){
            let {data,code,msg,message}  = await this.$RequestUtil.getAsync({url: '/api/select/listMaterial', params: {materialCode,materialName,specification,stockOutType:this.addForm.stockOutType}})
            if(code==0){
                return data
            }
        },
        
     
        deleteMaterial(index){
            let num = this.addForm.stockList[index].num
            this.addForm.stockList.splice(index,num)
        },

        addMaterial(){
            if(!this.addForm.stockOutType){
                this.$message.error('请先选择出库类型')
                return
            }
            let index = this.addForm.stockList.length
            this.addForm.stockList.push({num:1,unitTypeList:[],materialList:CommonUtils.cloneObj(this.materialBaseList)})
        },
        
        backToOrderView() {
            this.$parent.reload()
            this.$parent.showPage = 1;
        },
    }
}
</script>
<style scoped>

 .value{
    display:inline-block
}
.stock_in_Detail{
    width: 100%;
    height: 100%;
}
.delete{
    width: 18px;
    height: 19px;
    background-image:url('../../../static/img/del.png');
    cursor: pointer;
    background-repeat: no-repeat;
     margin-left: 4px;
}
.delete:hover{
    background-image: url('../../../static/img/del-hover.png');
    background-repeat: no-repeat;
}
</style>
<style>
.select_width{
	width: 139px;
}
.stock_in_Detail .add{
    width: 19px;
    height: 19px;
    background-image:url('../../../static/img/add.png');
    cursor: pointer;
    background-repeat: no-repeat;
    margin-top: 10px
}
.stock_in_Detail .el-form-item--mini.el-form-item, .stock_in_Detail .el-form-item--small.el-form-item{
    margin-top: 7px;
    margin-bottom: 13px;
}
.stock_in_Detail .el-table::before {
    height: 0px;
}
.stock-material::before{
    /* background-color: #fff !important; */
    border: none;
    display: none;
}
</style>





// WEBPACK FOOTER //
// src/views/stock/StockOutDetail.vue